import type { OnAirLight } from '@rabbitfuel/shared';

/**
 * Die Ampel „bin ich live?" -- drei Lampen und ein Satz dazu.
 *
 * Feste Ampelfarben statt der Hausfarbe: Rot, Gelb und Gruen muessen auch in
 * einem Browser eindeutig sein, der Rot oder Gruen als Hausfarbe gewaehlt hat.
 * Welche Lampe brennt, sagt `onAirLight` (shared).
 */
export function OnAirLamp({
  light,
  text,
  size = 'md',
  className,
}: {
  light: OnAirLight;
  text: string;
  /** `lg` auf der Senden-Seite, `sm` als Schild auf einer Vorschau. */
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}) {
  return (
    <div className={`ampel ampel--${light} ampel--${size}${className ? ` ${className}` : ''}`} role="status">
      <span className="ampel__lamps" aria-hidden>
        <i className="ampel__lamp ampel__lamp--red" />
        <i className="ampel__lamp ampel__lamp--yellow" />
        <i className="ampel__lamp ampel__lamp--green" />
      </span>
      <span className="ampel__text">{text}</span>
    </div>
  );
}
